import { z } from 'zod';

/**
 * ChMS connection events (issue #639). Emitted by the worker's
 * `getChmsConnection` and nothing else. Nothing is emitted for a ready or an
 * absent connection.
 *
 * `unusable` exists because a misconfigured integration (unrecognised source,
 * missing tokens) used to look like "needs re-auth" and sent the church a false
 * notice. It is reported here, never to the church.
 */
export const CHMS_CALLERS = [
  'PCOField',
  'PCOWorkflow',
  'UpdatePCOData',
  'SyncToIntegration',
  'createChildren',
  'getData',
] as const;

export type ChmsCaller = (typeof CHMS_CALLERS)[number];

const connectionFields = {
  /** The automation or job that asked for the connection. */
  caller: z.enum(CHMS_CALLERS),
  churchId: z.string(),
  /** The integration's `source`, or 'unknown' when the row carries none. */
  source: z.string(),
};

export const chmsSchemas = {
  'chms.connection_needs_reauth': z.object(connectionFields),
  'chms.connection_unusable': z.object(connectionFields),
};
